export class Paginador {
	metadata: {
		resultset: {
			offset: number;
			limit: number;
			count: number;
		};
	};
	results: any; // Array de objetos

	constructor(data) {
		if (data) {
			this.metadata = data.metadata;
			this.results = data.results;
		}
	}
}
